import './App.css'

export default () => {
  return (
    <div id="App">
      <p><acronym title='All Cops Are Bastards'>ACAB</acronym> wants to out-police the police.</p>

      <p>Ideally, a car (or combination of cars) carries a team of five people:</p>
      
      <ul>
        <li>The Driver responsible for the vehicle.</li>
        <li>The Cameraperson responsible for livestreaming everything to the cloud.</li>
        <li>The Muscle responsible for any physical tasks.</li>
        <li>The Liason responsible for interfacing with anyone external to the team.</li>
        <li>Comms responsible for tools and interfacing with the organization at large.</li>
      </ul>

      <p>Because of the pandemic, these five roles can be filled by two people. At the least, the Liason and the Cameraperson need to be separate people. The Cameraperson should be solely concerned with getting a recording of the events uploaded to the cloud.</p>

      <p>Like with 911, your first contact is with a dispatcher. They handle finding a team to respond.</p>

      <p>Patrols report their position to dispatch. Participants are paid a fixed wage for time on patrol or training.</p>

      <p>I would like all counter-police activities to be saved in the cloud and have some system of governance for its publicity. The simplest way to do it is to make all activities public, but that could dissuade people with private situations from using the service.</p>

      <p>I would like to see the widespread use of non-lethal rounds. I would like a general rule that firearms will never be brandished first by our agents.</p>

      <p>One initial focus is traffic stops. As someone is getting stopped, they tell their smart phone and active patrols are notified.</p>

      <p>The vehicle pulls in front of the stop and the Liason followed by the Cameraperson approach the scene.</p>

      <p>One common police tactic is swarming and overpowering any opposition through sheer numbers. I want the responding team to be able to call in more teams if this happens.</p>

      <ul>
        <li><button>Patrols In Your Area</button></li>
      </ul>

      <p>When the pair is in the car without a call they operate as couriers for both ridesharers and goods.</p>

      <p>If a ride is interrupted by a call, the dispatcher handles rerouting anything in the car.</p>
    </div>
  )
}